import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import H6 from 'UIComponents/elements/headings/H6';
import { Table, TopHeaderCell } from './FeatureStyledComponents';

const FeaturesMobileTableHeader = ({
  activeColumn,
  headerKeys
}) => /*#__PURE__*/_jsx(Table, {
  children: /*#__PURE__*/_jsx("thead", {
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("th", {}), headerKeys.map((headerKey, i) => {
        if (i === 0 || i - 1 === activeColumn) {
          return /*#__PURE__*/_jsx(TopHeaderCell, {
            "data-key": i - 1,
            children: /*#__PURE__*/_jsx(H6, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `upgrades.productCatalog.tableHeader.${headerKey}`
              })
            })
          }, i);
        }

        return null;
      })]
    })
  })
});

export default FeaturesMobileTableHeader;